<template>
  <div class="p-fluid p-formgrid p-grid">

    <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                       <i class="pi pi-user"></i>
                    </span>
      <InputText id="username" placeholder="Benutzername" v-model="userChanges.username"></InputText>
    </div>

    <div class="p-inputgroup p-mt-2">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-user"></i>
                        </span>
      <InputText id="name" placeholder="Vorname" v-model="userChanges.name"></InputText>
      <span class="p-inputgroup-addon">
                        <i class="pi pi-user"></i>
                    </span>
      <InputText id="surname" placeholder="Nachname" v-model="userChanges.surname"></InputText>
    </div>

    <div class="p-inputgroup p-mt-2">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-envelope"></i>
                    </span>
      <InputText id="street" placeholder="Strasse" v-model="userChanges.street"></InputText>
    </div>

    <div class="p-inputgroup p-mt-2">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-user"></i>
                        </span>
      <InputText id="zipCode" placeholder="PLZ" v-model="userChanges.zipCode"></InputText>
      <span class="p-inputgroup-addon">
                        <i class="pi pi-user"></i>
                    </span>
      <InputText id="city" placeholder="Ort" v-model="userChanges.city"></InputText>
    </div>

    <div class="p-inputgroup p-mt-2">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-envelope"></i>
                    </span>
      <InputText id="email" placeholder="Email" v-model="userChanges.email"></InputText>
    </div>

    <div class="p-inputgroup p-mt-2">
                    <span class="p-inputgroup-addon">
                       <i class="pi pi-user"></i>
                    </span>
      <img v-if="userChanges.url" :src="userChanges.url" class="profile-image-preview">
    </div>

    <div class="p-mt-2">
      <AvatarCropper @image-cropped="onImageCropped" @crop-cancelled="onCropCancelled"/>
    </div>

    <div v-if="isAdmin()" class="p-inputgroup">
      <span class="p-inputgroup-addon p-mt-2">

        <div v-for="role of roles" :key="role.name" class="p-field-checkbox p-mr-2">
        <CheckBox :id="role.name" :value="role" v-model="userChanges.roles"
                  :disabled="role.name === 'user' && role.selected"/>
        <label class="p-mt-2" :for="role.name">{{ role.name }}</label>
      </div>

      </span>
    </div>

    <div class="p-mt-2">
      <Button @click="handleSubmit" class="p-button-rounded p-button-outlined" icon="pi pi-check"></Button>
      <Button @click="closePwDialog" class="p-button-rounded p-button-outlined"
              icon="pi pi-times"></Button>
    </div>

  </div>
</template>

<script>
import UserService from '../services/user.service';
import AuthService from "@/services/auth.service";
import UploadService from "@/services/upload-files.service";
import AvatarCropper from "@/components/AvatarCropper";

export default {
  name: "UserEdit",
  components: {
    AvatarCropper
  },
  props: {
    selectedUserProp: {
      type: Object
    }
  },
  data() {
    return {
      userChanges: {
        user_id: null,
        username: "",
        name: "",
        surname: "",
        email: "",
        street: '',
        zipCode: '',
        city: '',
        profileImageId: null,
        url: null,
        roles: []
      },
      message: "",
      progress: 0,
      selectedFiles: [],
      currentFile: undefined,
      roles: [],
      croppedImageBlob: null
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    handleSubmit() {
      UserService.postChanges(this.userChanges)
          .then(() => {
            this.$emit('close-dialog');
          }).catch(error => {
        console.error(error);
      });
    },
    closePwDialog() {
      this.$emit('close-dialog');
    },
    retrieveRoles() {
      AuthService.getAllRoles()
          .then(response => {
            this.roles = response.data
          })
          .catch(err => {
            console.log(err);
          });
    },
    async onImageCropped(croppedData) {
      this.croppedImageBlob = croppedData.blob;
      this.userChanges.url = croppedData.dataUrl;

      try {
        await UploadService.uploadUserImage(this.croppedImageBlob, event => {
          this.progress = Math.round((100 * event.loaded) / event.total);
        });
        this.$toast.add({severity: 'success', summary: 'Erfolg', detail: 'Profilbild aktualisiert', life: 3000});
      } catch (error) {
        this.$toast.add({severity: 'error', summary: 'Fehler', detail: 'Bild konnte nicht hochgeladen werden', life: 3000});
      }
    },

    onCropCancelled() {
      this.$toast.add({severity: 'info', summary: 'Abgebrochen', detail: 'Bildbearbeitung abgebrochen', life: 2000});
    },

    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }
      return false;
    },
    getCurrentUserProfile() {
      UserService.getUserById(this.selectedUserProp)
          .then(user => {
            this.userChanges.user_id = user.data._id;
            this.userChanges.username = user.data.username;
            this.userChanges.name = user.data.name;
            this.userChanges.surname = user.data.surname;
            this.userChanges.email = user.data.email;
            this.userChanges.zipCode = user.data.zipCode;
            this.userChanges.city = user.data.city;
            this.userChanges.street = user.data.street;
            this.userChanges.profileImageId = user.data.profileImageId;
            this.userChanges.url = null;
            this.userChanges.roles = user.data.roles;
          })
          .catch(err => {
            console.error(err);
          });
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else {
      this.retrieveRoles();
      if (this.selectedUserProp.id) {
        this.getCurrentUserProfile();
      } else {
        this.userChanges.user_id = this.selectedUserProp._id;
        this.userChanges.username = this.selectedUserProp.username;
        this.userChanges.name = this.selectedUserProp.name;
        this.userChanges.surname = this.selectedUserProp.surname;
        this.userChanges.email = this.selectedUserProp.email;
        this.userChanges.zipCode = this.selectedUserProp.zipCode;
        this.userChanges.city = this.selectedUserProp.city;
        this.userChanges.street = this.selectedUserProp.street;
        this.userChanges.profileImageId = this.selectedUserProp.profileImageId;
        this.userChanges.url = this.selectedUserProp.url;
        this.userChanges.roles = this.selectedUserProp.roles;
      }
    }
  }
}
</script>

<style scoped>
.profile-image-preview {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ccc;
}
</style>